// auth strings (es).
// Machine-drafted — review with a native speaker before launch.
const auth = {
	auth: {
		// Titles & headings
		signInTitle: 'Inicia sesión en tu cuenta',
		signUpTitle: 'Crea una cuenta nueva',
		signUpToAccount: 'Regístrate en tu cuenta',
		resetYourPassword: 'Restablece tu contraseña',

		// Links & secondary actions
		or: 'O',
		orLower: 'o',
		orDivider: 'O',
		createNewAccount: 'Crear una cuenta nueva',
		alreadyHaveAccountLogin: '¿Ya tienes una cuenta? Inicia sesión',
		alreadyHaveAccount: '¿Ya tienes una cuenta?',
		logIn: 'Iniciar sesión',
		forgotPassword: '¿Olvidaste tu contraseña?',

		// Buttons
		signIn: 'Iniciar sesión',
		signUp: 'Registrarse',
		signInWithGoogle: 'Iniciar sesión con Google',
		signUpWithGoogle: 'Registrarse con Google',
		send: 'Enviar',

		// Field labels & placeholders
		emailAddress: 'Correo electrónico',
		yourEmailAddress: 'Tu correo electrónico',
		emailPlaceholder: 'tu@ejemplo.com',
		enterEmailAddress: 'Introduce tu correo electrónico',
		password: 'Contraseña',
		enterPassword: 'Introduce tu contraseña',
		rememberMe: 'Recordarme',

		// Terms & consent
		agreeToOur: 'Al registrarte, aceptas nuestros',
		termsOfService: 'términos de servicio',
		and: 'y',
		privacyPolicy: 'política de privacidad',

		// Invitation
		invitedToJoin: 'Te han invitado a unirte al espacio de trabajo %{workspace}',

		// Testimonials panel
		clientsSayHeading: 'Lo que dicen nuestros clientes',
		companiesTrust: 'Más de 1000 empresas construyen mejores relaciones con CardClan',

		// Alerts / dialog titles
		errorTitle: 'Error',
		successTitle: 'Listo',
		oops: '¡Vaya!',

		// Alert / validation messages
		passwordResetLinkSent: 'Te hemos enviado un enlace para restablecer tu contraseña por correo.',
		emailNotRegistered: 'Este correo no está registrado.',
		wrongPassword: 'La contraseña que ingresaste es incorrecta.',
		unknownError: 'Ocurrió un error desconocido. Contacta con soporte en support@cardclan.io.',
		invalidEmail: 'Formato de correo no válido',
		emailRequired: 'El correo es obligatorio',
		passwordRequired: 'La contraseña es obligatoria',
		passwordRules:
			'La contraseña debe tener entre 6 y 18 caracteres, con al menos 1 mayúscula, 1 minúscula y 1 número.',
	} as Record<string, string>,
};
export default auth;
